export default {
    
    indexOccurrenceSheetMotives:        { method: 'get',    url: 'occurrence_sheet_register_motives' },
    createOccurrenceSheetMotive:       { method: 'post',   url: 'occurrence_sheet_register_motives'},
    updateOccurrenceSheetMotive:       { method: 'put',    url: 'occurrence_sheet_register_motives/{id}'},
    destroyOccurrenceSheetMotive:       { method: 'delete', url: 'occurrence_sheet_register_motives/{id}'},
}